<template>
  <Box>
    <BoxHead icon="fas fa-home">
      Estate Planning
    </BoxHead>

    <BoxLoader v-if="loading" />

    <EmptySection
      v-else-if="isEmpty"
      :badges="['Estate']"
    />

    <template v-else>
      <Callout
        v-if="estatePlanning?.alert"
        :class="estatePlanning.alertClass"
        status="danger"
        icon-before="fas fa-exclamation-triangle"
      >
        {{ estatePlanning.alert }}
      </Callout>

      <DetailsGrid>
        <DetailPair
          variant="vertical"
          label="Power of Attorney"
        >
          <Badge
            v-if="estatePlanning?.has_power_of_attorney"
            status="success"
          >
            Yes
          </Badge>
          <Badge
            v-else
            status="danger"
          >
            No
          </Badge>
        </DetailPair>

        <DetailPair
          variant="vertical"
          label="Will"
        >
          <Badge
            v-if="estatePlanning?.has_will"
            status="success"
          >
            Yes
          </Badge>
          <Badge
            v-else
            status="danger"
          >
            No
          </Badge>
        </DetailPair>

        <DetailPair
          variant="vertical"
          label="Healthcare Directive"
        >
          <Badge
            v-if="estatePlanning?.has_healthcare_directive"
            status="success"
          >
            Yes
          </Badge>
          <Badge
            v-else
            status="danger"
          >
            No
          </Badge>
        </DetailPair>

        <DetailPair
          v-if="estatePlanning?.willBeneficiaries && estatePlanning.willBeneficiaries.length > 0"
          variant="vertical"
          label="Will Beneficiaries"
          :value="estatePlanning.willBeneficiaries.join(', ')"
        />

        <DetailPair
          v-if="estatePlanning?.willDate"
          variant="vertical"
          label="Will Date"
          :value="estatePlanning.willDate"
        />

        <DetailPair
          variant="vertical"
          label="Trusts"
        >
          <Badge
            v-if="estatePlanning?.has_trusts"
            status="success"
          >
            Yes
          </Badge>
          <Badge
            v-else
            status="danger"
          >
            No
          </Badge>
        </DetailPair>
      </DetailsGrid>

      <Stack
        v-if="estatePlanning?.trusts && estatePlanning.trusts.length > 0"
        gap="2"
      >
        <DetailsTitle>Trusts</DetailsTitle>

        <DetailsList
          v-for="(trust, index) in estatePlanning.trusts"
          :key="index"
          variant="boxed"
        >
          <DetailPair
            :label="`${trust.type} ${trust.name ? trust.name : ''}`"
            variant="heading"
          />

          <DetailPair
            v-if="trust.establishment_date"
            label="Established"
            :value="trust.establishment_date"
          />

          <DetailPair
            label="Trustee"
            :value="trust.trustee"
          />

          <DetailPair
            v-if="trust.beneficiaries && trust.beneficiaries.length > 0"
            label="Beneficiaries"
            :value="trust.beneficiaries.join(', ')"
          />

          <DetailPair
            v-if="trust.assets && trust.assets.length > 0"
            label="Assets"
            :value="trust.assets.join(', ')"
          />

          <DetailPair
            v-if="trust.notes"
            label="Assets"
            :value="trust.notes"
          />
        </DetailsList>
      </Stack>
    </template>
  </Box>
</template>

<script setup>
import { computed } from 'vue';
import { Badge, Box, BoxHead, BoxLoader, Callout, Stack, DetailsGrid, DetailPair, DetailsList, DetailsTitle } from '@stakeui';
import EmptySection from './EmptySection.vue';
import { isEmptyValue } from '@frontend/shared/Util.js';

const props = defineProps({
  client: {
    type: Object,
    default: null,
  },
  loading: {
    type: Boolean,
    default: false,
  },
});

const estatePlanning = computed(() => props.client?.estatePlanning);
const isEmpty = computed(() => isEmptyValue(estatePlanning.value));
</script>
